import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-box-layout',
  templateUrl: './box-layout.component.html',
  styleUrls: ['./box-layout.component.scss']
})
export class BoxLayoutComponent implements OnInit {

  @Input() boxData: any;

  constructor() { }

  ngOnInit(): void {
  }

}
